import React, { Component } from 'react';
import { connect } from 'react-redux';
import '../../css/modal.scss';
import BackspaceIcon from '../../img/keyboard/backspace.png';
import ResetIcon from '../../img/keyboard/reset.png';

class PriceInputModal extends Component {
  constructor(props) {
    super(props);
    this.state = {};
  }

  render() {
    const { isOpen, close } = this.props;
    return (
      <>
        {isOpen && this.props.posReducer.keyboardSetting ? (
          <>
            <div
              className={this.props.inline ? '' : 'Modal-overlay-empty'}
              onClick={close}
            />
            <div className={this.props.inline ? '' : 'Modal-empty'}>
              <div
                className="keyboard-container desk"
                style={{ maxWidth: '490px' }}>
                {this.props.diableAdd ? null : (
                  <div className="keyboard-set" style={{ maxWidth: '480px' }}>
                    <div
                      className="keyboard-green-horizontal"
                      onClick={() => this.props.keyadd(10000)}>
                      <div>+10,000</div>
                    </div>
                    <div
                      className="keyboard-green-horizontal"
                      onClick={() => this.props.keyadd(1000)}>
                      <div>+1,000</div>
                    </div>
                    <div
                      className="keyboard-green-horizontal"
                      onClick={() => this.props.keyadd(100)}>
                      <div>+100</div>
                    </div>
                  </div>
                )}
                <div className="keyboard-set" style={{ maxWidth: '320px' }}>
                  <div
                    className="keyboard-basic"
                    onClick={() => this.props.keyin(1)}>
                    <div>1</div>
                  </div>
                  <div
                    className="keyboard-basic"
                    onClick={() => this.props.keyin(2)}>
                    <div>2</div>
                  </div>
                  <div
                    className="keyboard-basic"
                    onClick={() => this.props.keyin(3)}>
                    <div>3</div>
                  </div>
                  <div
                    className="keyboard-basic"
                    onClick={() => this.props.keyin(0)}>
                    <div>0</div>
                  </div>
                  <div
                    className="keyboard-basic"
                    onClick={() => this.props.keyin(4)}>
                    <div>4</div>
                  </div>
                  <div
                    className="keyboard-basic"
                    onClick={() => this.props.keyin(5)}>
                    <div>5</div>
                  </div>
                  <div
                    className="keyboard-basic"
                    onClick={() => this.props.keyin(6)}>
                    <div>6</div>
                  </div>
                  <div
                    className="keyboard-basic"
                    onClick={() => this.props.keyin('00')}>
                    <div>00</div>
                  </div>
                  <div
                    className="keyboard-basic"
                    onClick={() => this.props.keyin(7)}>
                    <div>7</div>
                  </div>
                  <div
                    className="keyboard-basic"
                    onClick={() => this.props.keyin(8)}>
                    <div>8</div>
                  </div>
                  <div
                    className="keyboard-basic"
                    onClick={() => this.props.keyin(9)}>
                    <div>9</div>
                  </div>
                  <div
                    className="keyboard-basic"
                    onClick={() => this.props.keyin('000')}>
                    <div>000</div>
                  </div>
                </div>
                <div className="keyboard-set" style={{ maxWidth: '160px' }}>
                  <div
                    className="keyboard-gray"
                    onClick={() => this.props.backspace()}>
                    <div>
                      <img
                        style={{ display: 'inline' }}
                        src={BackspaceIcon}
                        alt=""
                      />
                    </div>
                  </div>
                  <div
                    className="keyboard-gray"
                    onClick={() => this.props.reset()}>
                    <div>
                      <img
                        style={{ display: 'inline' }}
                        src={ResetIcon}
                        alt=""
                      />
                    </div>
                  </div>
                  <div
                    className="keyboard-blue-large"
                    onClick={() => this.props.ok()}>
                    <div>확인</div>
                  </div>
                </div>
              </div>
            </div>

            {/* 반응형 */}

            <div className={this.props.inline ? '' : 'Modal-empty'}>
              <div
                className="keyboard-container pos"
                style={{ maxWidth: '310px' }}>
                {this.props.diableAdd ? null : (
                  <div className="keyboard-set" style={{ maxWidth: '300px' }}>
                    <div
                      className="keyboard-green-horizontal"
                      onClick={() => this.props.keyadd(10000)}>
                      <div>+10,000</div>
                    </div>
                    <div
                      className="keyboard-green-horizontal"
                      onClick={() => this.props.keyadd(1000)}>
                      <div>+1,000</div>
                    </div>
                    <div
                      className="keyboard-green-horizontal"
                      onClick={() => this.props.keyadd(100)}>
                      <div>+100</div>
                    </div>
                  </div>
                )}
                <div className="keyboard-set" style={{ maxWidth: '200px' }}>
                  <div
                    className="keyboard-basic"
                    onClick={() => this.props.keyin(1)}>
                    <div>1</div>
                  </div>
                  <div
                    className="keyboard-basic"
                    onClick={() => this.props.keyin(2)}>
                    <div>2</div>
                  </div>
                  <div
                    className="keyboard-basic"
                    onClick={() => this.props.keyin(3)}>
                    <div>3</div>
                  </div>
                  <div
                    className="keyboard-basic"
                    onClick={() => this.props.keyin(0)}>
                    <div>0</div>
                  </div>
                  <div
                    className="keyboard-basic"
                    onClick={() => this.props.keyin(4)}>
                    <div>4</div>
                  </div>
                  <div
                    className="keyboard-basic"
                    onClick={() => this.props.keyin(5)}>
                    <div>5</div>
                  </div>
                  <div
                    className="keyboard-basic"
                    onClick={() => this.props.keyin(6)}>
                    <div>6</div>
                  </div>
                  <div
                    className="keyboard-basic"
                    onClick={() => this.props.keyin('00')}>
                    <div>00</div>
                  </div>
                  <div
                    className="keyboard-basic"
                    onClick={() => this.props.keyin(7)}>
                    <div>7</div>
                  </div>
                  <div
                    className="keyboard-basic"
                    onClick={() => this.props.keyin(8)}>
                    <div>8</div>
                  </div>
                  <div
                    className="keyboard-basic"
                    onClick={() => this.props.keyin(9)}>
                    <div>9</div>
                  </div>
                  <div
                    className="keyboard-basic"
                    onClick={() => this.props.keyin('000')}>
                    <div>000</div>
                  </div>
                </div>
                <div className="keyboard-set" style={{ maxWidth: '100px' }}>
                  <div
                    className="keyboard-gray"
                    onClick={() => this.props.backspace()}>
                    <div>
                      <img
                        style={{ display: 'inline' }}
                        src={BackspaceIcon}
                        alt=""
                        style={{ width: 30 }}
                      />
                    </div>
                  </div>
                  <div
                    className="keyboard-gray"
                    onClick={() => this.props.reset()}>
                    <div>
                      <img
                        style={{ display: 'inline' }}
                        src={ResetIcon}
                        alt=""
                        style={{ width: 25 }}
                      />
                    </div>
                  </div>
                  <div
                    className="keyboard-blue-large"
                    onClick={() => this.props.ok()}>
                    <div>확인</div>
                  </div>
                </div>
              </div>
            </div>
          </>
        ) : null}
      </>
    );
  }
}

const mapStateToProps = (state) => {
  const { posReducer } = state;
  return { posReducer };
};
const mapDispatchToProps = (dispatch) => {};

export default connect(mapStateToProps, mapDispatchToProps)(PriceInputModal);
